<ng-container *ngIf="hasAccess">
  <!-- Botón Flotante (Launcher) -->
  <div class="chatbot-fab-container">
    <button
      type="button"
      class="chatbot-fab-btn"
      [class.chatbot-fab-active]="isOpen"
      (click)="toggleChat()"
      [attr.aria-label]="isOpen ? 'Cerrar Asistente' : 'Abrir Asistente'"
      title="Asistente Kosmos">
      <img *ngIf="!isOpen" src="assets/images/logo/adam-logo.jpg" class="chatbot-fab-logo" alt="ADAM" onerror="this.style.display='none'; this.nextElementSibling.style.display='block'">
      <i *ngIf="!isOpen" class="fa fa-comments chatbot-fab-icon" style="display: none;"></i>
      <i *ngIf="isOpen" class="fa fa-times chatbot-fab-icon"></i>
    </button>
  </div>

<!-- Ventana de Chat Flotante -->
<div
  class="chatbot-window-container"
  *ngIf="isOpen"
  [style.width.px]="customWidth"
  [class.chatbot-maximized]="isMaximized"
  [class.is-resizing]="isResizing">

  <!-- Borde interactivo para redimensionar ancho arrastrando con el mouse -->
  <div
    class="chatbot-resize-handle"
    (mousedown)="onStartResize($event)"
    (dblclick)="resetWidth()"
    title="Arrastra hacia la izquierda para ampliar el ancho (Doble clic para restablecer)">
    <div class="resize-handle-bar"></div>
  </div>

  <!-- Cabecera -->
  <div class="chatbot-header">
    <div class="chatbot-header-info">
      <div class="chatbot-avatar">
        <img src="assets/images/logo/adam-logo.jpg" class="chatbot-avatar-img" alt="ADAM" onerror="this.style.display='none'; this.nextElementSibling.style.display='block'">
        <i class="fa fa-robot" style="display: none;"></i>
      </div>
      <div class="chatbot-header-text">
        <span class="chatbot-title">Asistente Kosmos</span>
        <span class="chatbot-status">
          <span class="status-indicator"></span> En línea &bull; Consultas en tiempo real
        </span>
      </div>
    </div>
    <div class="chatbot-header-actions">
      <button
        type="button"
        class="btn-header-action"
        (click)="toggleMaximize()"
        [title]="isMaximized ? 'Restaurar tamaño vertical' : 'Ampliar al alto completo de la pantalla'">
        <i class="fa" [ngClass]="isMaximized ? 'fa-compress' : 'fa-expand'"></i>
      </button>
      <button
        type="button"
        class="btn-header-action"
        (click)="onClearChat()"
        title="Reiniciar conversación">
        <i class="fa fa-eraser"></i>
      </button>
      <button
        type="button"
        class="btn-header-action"
        (click)="closeChat()"
        title="Minimizar">
        <i class="fa fa-minus"></i>
      </button>
    </div>
  </div>

  <!-- Contenedor de Mensajes -->
  <div class="chatbot-messages-body" #messagesContainer>
    <div
      *ngFor="let msg of messages"
      class="chatbot-message-row"
      [ngClass]="msg.sender === 'user' ? 'msg-row-user' : 'msg-row-bot'">

      <!-- Avatar del Bot -->
      <div *ngIf="msg.sender === 'bot'" class="msg-bot-avatar">
        <i class="fa fa-robot"></i>
      </div>

      <!-- Contenido del Mensaje -->
      <div class="chatbot-bubble" [ngClass]="msg.sender === 'user' ? 'bubble-user' : 'bubble-bot'">
        
        <!-- Texto del mensaje con renderizado seguro de formato -->
        <div class="bubble-text" [innerHTML]="renderSafeMarkdown(msg.text)"></div>

        <!-- Renderizado de Métricas / KPIs (si aplica) -->
        <div *ngIf="msg.data?.metrics && msg.data!.metrics!.length > 0" class="chatbot-metrics-grid">
          <div *ngFor="let metric of msg.data!.metrics" class="chatbot-metric-card">
            <span class="metric-label">{{ metric.label }}</span>
            <span class="metric-value">{{ metric.value }}</span>
            <span *ngIf="metric.change" class="metric-badge" [class.badge-pos]="metric.isPositive">
              {{ metric.change }}
            </span>
          </div>
        </div>

        <!-- Renderizado de Tabla de Datos (si aplica) -->
        <div *ngIf="msg.data?.table && msg.data!.table!.rows.length > 0" class="chatbot-table-wrapper">
          <table class="table table-sm table-striped chatbot-data-table">
            <thead>
              <tr>
                <th *ngFor="let col of msg.data!.table!.columns">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of msg.data!.table!.rows">
                <td *ngFor="let cell of row">{{ cell }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Visualizador de Gráfico de Barras -->
        <div *ngIf="msg.activeChart === 'bar'" class="chatbot-chart-container bar-chart-box">
          <div class="chart-header">
            <span class="chart-title"><i class="fa fa-bar-chart me-1"></i> Gráfico de Barras</span>
            <button type="button" class="btn-close-chart" (click)="toggleChart(msg, 'bar')">&times;</button>
          </div>
          <div class="bar-chart-body">
            <div *ngFor="let item of getChartItems(msg)" class="bar-item">
              <div class="bar-item-info">
                <span class="bar-label text-truncate" [title]="item.label">{{ item.label }}</span>
                <span class="bar-val">{{ item.displayValue }} ({{ item.percentage }}%)</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" [style.width.%]="item.barWidthPercentage" [style.background-color]="item.color"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualizador de Gráfico de Pastel / Donut -->
        <div *ngIf="msg.activeChart === 'pie'" class="chatbot-chart-container pie-chart-box">
          <div class="chart-header">
            <span class="chart-title"><i class="fa fa-pie-chart me-1"></i> Gráfico de Pastel</span>
            <button type="button" class="btn-close-chart" (click)="toggleChart(msg, 'pie')">&times;</button>
          </div>
          <div class="pie-chart-body">
            <!-- Gráfico Donut SVG -->
            <div class="pie-svg-wrapper">
              <svg viewBox="0 0 42 42" class="pie-svg">
                <circle class="pie-hole" cx="21" cy="21" r="15.91549430918954" fill="#fff"></circle>
                <circle class="pie-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#e9ecef" stroke-width="6"></circle>
                <circle
                  *ngFor="let item of getChartItems(msg)"
                  class="pie-segment"
                  cx="21"
                  cy="21"
                  r="15.91549430918954"
                  fill="transparent"
                  [attr.stroke]="item.color"
                  stroke-width="6"
                  [attr.stroke-dasharray]="item.dashArray"
                  [attr.stroke-dashoffset]="item.dashOffset"></circle>
                <g class="pie-center-text">
                  <text x="50%" y="46%" class="pie-center-label">Total</text>
                  <text x="50%" y="62%" class="pie-center-val">{{ getChartTotal(msg) }}</text>
                </g>
              </svg>
            </div>
            <!-- Leyenda del Gráfico -->
            <div class="pie-legend">
              <div *ngFor="let item of getChartItems(msg)" class="pie-legend-item">
                <span class="legend-dot" [style.background-color]="item.color"></span>
                <span class="legend-text text-truncate" [title]="item.label">{{ item.label }}</span>
                <span class="legend-pct fw-bold">{{ item.percentage }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Barra de Acciones del Mensaje: Copiar, Descargar CSV y Graficar (solo en respuestas, no en saludo inicial) -->
        <div *ngIf="msg.sender === 'bot' && !msg.isWelcome && msg.id !== 'msg-welcome'" class="message-action-toolbar">
          <!-- Botón Copiar Respuesta -->
          <button
            type="button"
            class="btn-msg-action"
            [class.btn-copied]="copiedMessageId === msg.id"
            (click)="copyResponse(msg)"
            [title]="copiedMessageId === msg.id ? '¡Copiado!' : 'Copiar respuesta'">
            <svg *ngIf="copiedMessageId !== msg.id" class="icon-svg text-secondary" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            <svg *ngIf="copiedMessageId === msg.id" class="icon-svg text-success" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#28a745" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>

          <!-- Botón Descargar Excel / CSV -->
          <button
            type="button"
            class="btn-msg-action"
            (click)="downloadCSV(msg)"
            title="Descargar en Excel / CSV">
            <svg class="icon-svg text-success" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#107c41" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="8" y1="13" x2="16" y2="13"></line>
              <line x1="8" y1="17" x2="16" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </button>

          <ng-container *ngIf="isGraphable(msg)">
            <!-- Botón Gráfico de Barras -->
            <button
              type="button"
              class="btn-msg-action"
              [class.active-chart-btn]="msg.activeChart === 'bar'"
              (click)="toggleChart(msg, 'bar')"
              title="Gráfico de Barras">
              <svg class="icon-svg text-primary" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"></line>
                <line x1="12" y1="20" x2="12" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="14"></line>
              </svg>
            </button>

            <!-- Botón Gráfico de Pastel -->
            <button
              type="button"
              class="btn-msg-action"
              [class.active-chart-btn]="msg.activeChart === 'pie'"
              (click)="toggleChart(msg, 'pie')"
              title="Gráfico de Pastel">
              <svg class="icon-svg text-warning" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
              </svg>
            </button>
          </ng-container>
        </div>

        <!-- Timestamp del mensaje -->
        <div class="bubble-time">
          {{ msg.timestamp | date:'shortTime' }}
        </div>
      </div>
    </div>

    <!-- Indicador de "Escribiendo / Procesando..." -->
    <div *ngIf="isTyping" class="chatbot-message-row msg-row-bot">
      <div class="msg-bot-avatar">
        <img src="assets/images/logo/adam-logo.jpg" class="msg-bot-avatar-img" alt="ADAM" onerror="this.style.display='none'; this.nextElementSibling.style.display='block'">
        <i class="fa fa-robot" style="display: none;"></i>
      </div>
      <div class="chatbot-bubble bubble-bot typing-bubble">
        <div class="typing-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span class="typing-label">{{ processingStatus || 'Consultando datos seguros...' }}</span>
      </div>
    </div>

    <!-- Acciones / Sugerencias Rápidas -->
    <div
      *ngIf="messages.length > 0 && messages[messages.length - 1].suggestedActions && messages[messages.length - 1].suggestedActions!.length > 0"
      class="chatbot-suggestions-container">
      <span class="suggestions-title"><i class="fa fa-lightbulb-o"></i> Sugerencias:</span>
      <div class="suggestions-chips">
        <button
          *ngFor="let action of messages[messages.length - 1].suggestedActions"
          type="button"
          class="btn-suggestion-chip"
          [disabled]="isTyping"
          (click)="onSelectSuggestion(action)">
          {{ action }}
        </button>
      </div>
    </div>
  </div>

  <!-- Pie / Input de Texto -->
  <div class="chatbot-footer">
    <div class="chatbot-input-wrapper">
      <input
        type="text"
        class="form-control chatbot-input"
        placeholder="Escribe tu consulta aquí..."
        [(ngModel)]="inputText"
        (keydown)="onKeyDown($event)"
        [disabled]="isTyping"
        maxlength="500" />
      <button
        type="button"
        class="btn btn-primary chatbot-send-btn"
        (click)="onSubmit()"
        [disabled]="!inputText.trim() || isTyping"
        title="Enviar mensaje">
        <i class="fa fa-paper-plane"></i>
      </button>
    </div>
    <div class="chatbot-footer-hint">
      <small><i class="fa fa-shield"></i> Consultas protegidas según tu rol de usuario</small>
    </div>
  </div>
</div>
</ng-container>
